import { config } from '@services/config';
import { BrokerageCustomerMetadataGetResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCustomerBrokerageMetadata = (customerId?: string) => {
  const client = useClient();
  const result = useQuery<BrokerageCustomerMetadataGetResponse>({
    queryKey: customerQueryKey.getBrokerageMetadata({ customerId }),
    queryFn: () => client.get(`customer/${customerId}/brokerage/metadata`).json<BrokerageCustomerMetadataGetResponse>(),
    enabled: !!customerId,
    ...config,
  });
  return { ...result, customerBrokerageMetadata: result.data };
};
